<template>
  <form id="frm_action">
    <div class="p-formgrid row">
      <div class="col-lg-6">
        <div class="mt-3">
          <label class="txt-right required">Tên loại</label>
          <InputText
            v-model="name"
            id="name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            :disabled="mode=='edit'"
          />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Mã loại</label>
          <InputText v-model="code" id="code" type="text" class="text-box input-text-box" placeholder="Nhập" @input="code = code.toUpperCase().replace(/\s/g,'')" :disabled="mode=='edit'"/>
        </div>
        <div class="mt-3">
          <label class="txt-right required">Trọng lượng nhập (gam)</label>
          <InputNumber v-model="weight" id="weight" class="text-box input-text-box" mode="decimal" locale="de-DE" :minFractionDigits="2" :maxFractionDigits="3" placeholder="Nhập"/>
        </div>
        <div class="mt-3">
          <label class="txt-right required">Tốc độ tăng trưởng (%/ngày)</label>
          <InputNumber v-model="growth" id="growth" class="text-box input-text-box" mode="decimal" locale="de-DE" :minFractionDigits="2" :maxFractionDigits="3" placeholder="Nhập"/>
        </div>
        <div class="mt-3">
          <label class="txt-right required">Số ngày tăng trưởng</label>
          <InputText v-model="number_days_growth" id = "number_days_growth" type="float" class="text-box input-text-box" @input="number_days_growth = number_days_growth.replace(/[^0-9]/g, '')" placeholder="Nhập"/>
        </div>
        <div class="mt-3 d-flex align-items-center p-0">
          <Checkbox id="active" v-model="active" :binary="true" />
          <label for="active" class="m-0 ml-2">Hiển thị</label>
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar col-lg-12">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DataServices from "@/core/DataServices";
// import ApiRepository from "@/core/ApiRepository";
export default {
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      name: "",
      code: "",
      weight: 0,
      growth: 0,
      number_days_growth: 0,
      active: true,
    };
  },
  async mounted() {
    // console.log("this.model", this.model);
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.$commonFuction.is_loading(true);
      this.name = this.model.name;
      this.code = this.model.code;
      this.weight = this.model.weight;
      this.growth = this.model.growth;
      this.number_days_growth = this.model.number_days_growth;
      this.active = this.model.active;
      this.$commonFuction.is_loading(false);
    }
  },
  watch: {},
  methods: {
    backToList() {
      this.$emit("back");
    },
    async validateData() {
      this.validationErrors = {};

      let name_add = document.getElementById("name");
      if (
        this.name == undefined ||
        this.name == null ||
        this.name == ""
      ) {
        name_add.setCustomValidity("Tên loại không được để trống!");
      } else {
        name_add.setCustomValidity("");
      }

      let code_add = document.getElementById("code");
      if (
        this.code == undefined ||
        this.code == null ||
        this.code == ""
      ) {
        code_add.setCustomValidity("Mã loại không được để trống!");
      } else if (this.code.length > 50) {
        code_add.setCustomValidity("Mã loại không được quá 50 ký tự!");
      } else if (await this.existCode()) {
        code_add.setCustomValidity("Mã loại đã tồn tại!");
      } else {
        code_add.setCustomValidity("");
      }
      
      let weight_add = document.getElementById("weight");
      if (
        this.weight == undefined ||
        this.weight == null ||
        this.weight == ""
      ) {
        weight_add.setCustomValidity("Trọng lượng nhập không được để trống!");
      } else {
        weight_add.setCustomValidity("");
      }

      let growth_add = document.getElementById("growth");
      if (
        this.growth == undefined ||
        this.growth == null ||
        this.growth == ""
      ) {
        growth_add.setCustomValidity("Tốc độ tăng trưởng không được để trống!");
      } else {
        growth_add.setCustomValidity("");
      }

      let number_days_growth_add = document.getElementById("number_days_growth");
      if (
        this.number_days_growth == undefined ||
        this.number_days_growth == null ||
        this.number_days_growth == ""
      ) {
        number_days_growth_add.setCustomValidity("Số ngày tăng trưởng không được để trống!");
      } else {
        number_days_growth_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async existCode() {
      var gqLQueryList = DataServices.getList("kind", {"fields": "id"});
      var where = {
          code: {_eq: this.code},
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
        },
      });
      var listData = resData.data["kind"];
      if (listData.length > 0) {
        return true;
      }
      return false;
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }
      var params = {
        name: this.name,
        code: this.code,
        weight: this.weight,
        growth: this.growth,
        number_days_growth: this.number_days_growth,
        active: this.active,
      };
      // console.log("saveData", params);
      this.$emit("save", params);
      // }
    },
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 480px;
  height: 270px;
  position: relative;
  padding: 0;
}
.p-multiselect-panel .p-checkbox.p-component {
  display: none !important;
}
</style>
